import { render, staticRenderFns } from "./DataModels.vue?vue&type=template&id=4cab2a98&"
import script from "./DataModels.vue?vue&type=script&lang=ts&"
export * from "./DataModels.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports